<template lang="pug">
  div
    h2(class="new-advert-subtitle mb-2") Цена:
    v-row()
      v-col(cols="6")
        v-text-field(
          v-model.number="price",
          ref="priceInput"
          outlined,
          dense,
          clearable,
          label="цена",
          placeholder="Укажите цену",
          :error-messages="error")
      v-col(cols="2")
        v-select(
          v-model="currency",
          :items="currencyList",
          item-text="text",
          item-value="key",
          dense,
          outlined,
          label="Валюта")
</template>

<script>
export default {
  name: 'Price',
  props: {
    currencyList: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.$refs.priceInput.$refs.input.onkeydown = this.onChange
  },
  data: () => ({
    price: null,
    currency: 'som',
    error: ''
  }),
  watch: {
    currency(val) {
      this.$emit('set-currency', val)
    },
    price(val) {
      this.$emit('set-price', val)
    }
  },
  methods: {
    onChange(e) {
      const a = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight']
      if (a.includes(e.key)) {
        return
      }
      if (`${e.key}`.search(/\D/) !== -1) {
        this.error = 'Пожалуйста только цифры'
        e.preventDefault()
        return
      }
      this.error = ''
    }
  }
}
</script>
